import produce from 'immer';

const INITIAL_STATE = {
  translate: [],
  loading: false,
};

export default function language(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@lang/REQUEST_TRANSLATE': {
        draft.loading = true;
        break;
      }

      case '@lang/SUCCESS_TRANSLATE': {
        draft.loading = false;
        draft.translate = action.payload.lang;
        break;
      }

      case '@lang/FAILED_TRANSLATE': {
        draft.loading = false;
        break;
      }

      case '@auth/SIGN_OUT': {
        draft.loading = false;
        draft.translate = [];
        break;
      }

      default:
    }
  });
}
